import classNames from 'classnames';
import AddToCalendar from '@components/add-to-calendar';
import Button from '@components/button';
import OpenHousesDropdown from '@components/openhouses-dropdown';
import TabSlider from '@components/tab-slider';
import { parseDateWithFormatMMMDDAndTime } from '@lib/utils';
import { pushDataLayerEvent } from '@lib/gtm';
import { useListingContext } from '../../context';
import { useRouter } from 'next/router';

import {
  top_section,
  virtual_tour,
  alerts_container,
  base_alert,
  base_alert_coming_soon,
  base_alert_pending,
  base_alert_price_change,
  base_alert_listed_on,
  add_to_calendar,
  tabs,
  is_desktop,
  is_mobile
} from './styles.module.scss';

const PropertyAlerts = ({ setSelectedArea }) => {
  const router = useRouter();
  const {
    alerts,
    openHouses,
    isIdxListing,
    canonicalUrl,
    address,
    city,
    state,
    zip,
    videoUrl,
    virtualTourUrl,
    longitude,
    latitude,
    displayAgents
  } = useListingContext();

  const hasOpenHouse = openHouses[0];
  const showMap = !!longitude && !!latitude && latitude !== 0 && longitude !== 0;

  const dates = openHouses.map((openHouse) => {
    return parseDateWithFormatMMMDDAndTime(openHouse.formattedDateTimeDisplay);
  });

  const pendingAlert = alerts?.filter((alert) => alert.type === 'Pending');
  const listedOnAlert = alerts?.filter((alert) => alert.type === 'ListedOn');
  const priceChangeAlert = alerts?.filter((alert) => alert.type === 'PriceChange');
  const comingSoonAlert = alerts?.filter((alert) => alert.type === 'ComingSoon');

  const uniqVirtualTourUrl = virtualTourUrl !== videoUrl ? virtualTourUrl : null;

  const tabItems = [
    (videoUrl || showMap) && {
      icon: {
        name: 'photos',
        type: 'filters'
      },
      label: 'Photos'
    },
    videoUrl && {
      icon: {
        name: 'video',
        type: 'filters'
      },
      label: 'Video Tour'
    },
    showMap && {
      icon: {
        name: 'location',
        type: 'filters'
      },
      label: 'Map'
    }
  ].filter((item) => item);

  const primaryAgent = displayAgents[0];

  return (
    <section className={top_section}>
      <div className={is_desktop}>
        <div className={tabs}>
          <TabSlider items={tabItems} setSelectedTabCallback={setSelectedArea} />
        </div>
      </div>
      <div className={top_section}>
        {uniqVirtualTourUrl && (
          <div
            className={classNames(is_mobile, virtual_tour)}
            onClick={() => pushDataLayerEvent('listing_virtual_tour_click', router.asPath)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ')
                pushDataLayerEvent('listing_virtual_tour_click', router.asPath);
            }}
            role="button"
            tabIndex="0"
          >
            <Button
              label="Virtual Tour"
              theme="black"
              url={virtualTourUrl}
              target="_blank"
              icon="video"
            />
          </div>
        )}

        <div className={alerts_container}>
          {pendingAlert?.length > 0 && (
            <div>
              <h3 className={classNames(base_alert, base_alert_pending)}>
                {pendingAlert[0]?.text}
              </h3>
            </div>
          )}

          {listedOnAlert?.length > 0 && (
            <div>
              <h3 className={classNames(base_alert, base_alert_listed_on)}>
                {listedOnAlert[0]?.text}
              </h3>
            </div>
          )}

          {priceChangeAlert?.length > 0 && (
            <div>
              <h3 className={classNames(base_alert, base_alert_price_change)}>
                {priceChangeAlert[0]?.text}
              </h3>
            </div>
          )}

          {comingSoonAlert?.length > 0 && (
            <div>
              <h3 className={classNames(base_alert, base_alert_coming_soon)}>
                {comingSoonAlert[0]?.text}
              </h3>
            </div>
          )}

          {hasOpenHouse && (
            <OpenHousesDropdown
              label={openHouses[0].formattedDateTimeDisplay}
              openHouses={openHouses}
            />
          )}
        </div>

        {hasOpenHouse && !isIdxListing && (
          <div className={add_to_calendar}>
            <AddToCalendar
              label="Add Open House to Calendar"
              name="Open House"
              description={`See listing details and confirm open house time here:\n${canonicalUrl}\n\nFor information about this property or to schedule a private showing:\n${
                primaryAgent?.displayPrimary
              }\n${primaryAgent?.displayPhone || ''}\n${primaryAgent?.displayEmail || ''}`}
              location={`${address}, ${city}, ${state} ${zip}`}
              dates={dates}
              timeZone="America/New_York"
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default PropertyAlerts;
